module.exports = __webpack_public_path__ + "img/fruit-blueberries-350x184.46d5fcbb.jpg";